import React from "react";

interface TrustedByProps {
  contractorCount?: number;
}

const contractors = [
  {
    name: "Knight Commercial",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/662070cdf4199d406174f075_knight-p-800-1.png",
  },
  {
    name: "Ramjack West",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/662070cdea6bba6a40631f3d_ramjack-2.png",
  },
  {
    name: "WJ O'Neil",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/Vector.png",
  },
  {
    name: "Green Mechanical",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2024/08/ChatGPT-Image-Apr-24-2025-11_19_51-PM-3-1.png",
  },
  {
    name: "Inland Building Construction",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/662070cc7aa75f6a7dc7517b_inland-1.png",
  },
  {
    name: "Kaufman Lynn Construction",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/05/dark.png",
  },
  {
    name: "American Roofing",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/662070cd1320098e6ec8243d_amr-p-500-1.png",
  },
  {
    name: "Perry McCall",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/662070cdc8b0a18c35ae5825_perrymccall-p-500-1.png",
  },
  {
    name: "Truebeck",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/662070ccd19641ced6a412f2_truebeck-p-800-1.png",
  },
  {
    name: "Almendariz Consulting",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/acilogo_hor_all_clr_no-border-1.png",
  },
  {
    name: "A-1 Modular",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/03/662070cc4db8ffd71d56afe9_a1-1.png",
  },
  {
    name: "Meco LLC",
    logo: "https://mitercms.wpenginepowered.com/wp-content/uploads/2025/04/meco-llc-logo-dark-1.png",
  },
];

const ContractorLogo: React.FC<{ name: string; logo: string }> = ({ name, logo }) => (
  <div className="flex items-center justify-center p-4">
    <img
      alt={`${name} logo`}
      loading="lazy"
      className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
      src={logo}
    />
  </div>
);

export const TrustedBy: React.FC<TrustedByProps> = ({ contractorCount = 15320 }) => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="mx-auto w-full max-w-7xl px-4">
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Có hơn {contractorCount.toLocaleString()}+ đối tác
          </h2>
          <p className="text-gray-600">
            Đồng hành cùng doanh nghiệp trên toàn quốc.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {contractors.map((contractor) => (
            <ContractorLogo key={contractor.name} name={contractor.name} logo={contractor.logo} />
          ))}
        </div>
      </div>
    </section>
  );
};
